import services from 'services/module';

export class LandingTemplateSvc {
    isLink: boolean;

    constructor(private $state: ng.ui.IStateService) {
        this.randomize();
    }

    getTrackInfo() {
        return {
            'Landing Page': this.$state.current.name,
            'Test Variant': this.isLink ? 'with-links' : 'without-links'
        };
    }

    private randomize() {
        const val   = _.random(0, 1);
        this.isLink = !!val;
    }
}

services.service('landingTemplateSvc', LandingTemplateSvc);



// WEBPACK FOOTER //
// ./app/assets/javascripts/services/landingTemplateSvc.ts